export default __webpack_public_path__ + "static/media/NIAS0270.34I-29144_-16938_0.8ecb7d50.jpg";